import { isSameDate } from '../../../utils'
import isWeekend from './isWeekend'
import isOutside from './isOutside'
import isDisabled from './isDisabled'
import getRangeProps from './getRangeProps'

export type GetDayProps = {
    date: Date
    month: Date
    hasValue: boolean
    maxDate: Date
    minDate: Date
    value: Date
    disableDate: (date: Date) => boolean
    disableOutOfMonth: boolean
    range: [Date, Date]
    selectionRange: [Date, Date]
    weekendDays: number[]
}

export type GetDayPropsReturn = {
    disabled: boolean
    weekend: boolean
    selectedInRange: boolean
    selected: boolean
    isSelecting: boolean
    inRange: boolean
    firstInRange: boolean
    lastInRange: boolean
    outOfMonth: boolean
}

export default function getDayProps(props: GetDayProps): GetDayPropsReturn {
    const {
        date,
        month,
        hasValue,
        minDate,
        maxDate,
        value,
        disableDate,
        disableOutOfMonth,
        range,
        selectionRange,
        weekendDays,
    } = props

    const outOfMonth = isOutside(date, month)
    const selected =
        hasValue &&
        (Array.isArray(value)
            ? value.some((val) => isSameDate(val, date))
            : isSameDate(date, value))
    const { inRange, lastInRange, firstInRange, selectedInRange } =
        getRangeProps(date, range)

    const { inRange: isSelecting } =
        getRangeProps(date, selectionRange)

    return {
        disabled: isDisabled({
            minDate,
            maxDate,
            disableDate,
            disableOutOfMonth,
            date,
            outOfMonth,
        }),
        weekend: isWeekend(date, weekendDays),
        selectedInRange,
        selected,
        isSelecting,
        inRange,
        firstInRange,
        lastInRange,
        outOfMonth,
    }
}
